var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilyplus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 79,
    viewBox: "0 0 75 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.2965C0 16.7281 13.4313 3.29688 29.9996 3.29688H44.9994C61.5677 3.29688 74.999 16.7281 74.999 33.2965V48.2963C74.999 64.8646 61.5677 78.2958 44.9994 78.2958H29.9996C13.4313 78.2958 0 64.8646 0 48.2962L0 33.2965Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 51.8125H59.0575L58.938 53.0062C58.5681 55.9518 56.4635 57.6717 54.3247 57.6717H22.4242C20.007 57.6717 18.1149 55.6008 17.8136 53.0281C17.8102 53.0013 17.8268 53.1645 17.6914 51.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8721 33.8201L59.3316 49.1852H17.4401L15.9357 34.1462C15.5331 30.6196 19.3556 28.9896 21.1203 31.0076C25.366 35.8794 25.8205 36.8411 27.2468 36.6718C27.7829 36.6069 28.1659 36.3679 28.484 36.0763C37.1281 27.8235 36.5628 28.3579 36.6518 28.2879C37.8152 27.3973 39.3113 27.5442 40.1878 28.2704C48.9221 35.5738 48.5174 35.2522 48.7124 35.3627C49.5279 35.8291 50.4897 35.7697 51.3117 34.9674C56.1656 30.2213 55.8578 30.517 55.9478 30.4453C58.1682 28.725 61.2275 30.7241 60.8721 33.8201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.9996C0 13.4313 13.4313 0 29.9996 0L44.9994 0C61.5677 0 74.999 13.4313 74.999 29.9996L74.999 44.9994C74.999 61.5677 61.5677 74.999 44.9994 74.999H29.9996C13.4313 74.999 0 61.5677 0 44.9994L0 29.9996Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 48.5156H59.0575L58.938 49.7093C58.5681 52.655 56.4635 54.3749 54.3247 54.3749H22.4242C20.007 54.3749 18.1149 52.3039 17.8136 49.7312C17.8102 49.7044 17.8268 49.8676 17.6914 48.5156Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8721 30.5232L59.3316 45.8884H17.4401L15.9357 30.8494C15.5331 27.3227 19.3556 25.6927 21.1203 27.7107C25.366 32.5825 25.8205 33.5442 27.2468 33.375C27.7829 33.3101 28.1659 33.0711 28.484 32.7794C37.1281 24.5266 36.5628 25.0611 36.6518 24.991C37.8152 24.1004 39.3113 24.2473 40.1878 24.9735C48.9221 32.2769 48.5174 31.9553 48.7124 32.0658C49.5279 32.5322 50.4897 32.4728 51.3117 31.6705C56.1656 26.9244 55.8578 27.2201 55.9478 27.1484C58.1682 25.4281 61.2275 27.4272 60.8721 30.5232Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.72565e-7,
    y1: 7.00321,
    x2: 80.108,
    y2: 12.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD4363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3643F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 3.72565e-7,
    y1: 3.70634,
    x2: 80.108,
    y2: 9.46306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE875F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyplus);
export default __webpack_public_path__ + "static/media/familyplus.2024872030145fbbda43da55798c5767.svg";
export { ForwardRef as ReactComponent };